// filepath: frontend/src/store/uiStore.ts
import { create } from 'zustand';

interface UIState {
  commandPaletteOpen: boolean;
  setCommandPaletteOpen: (open: boolean) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  offlinePending: number;
  setOfflinePending: (count: number) => void;
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
  darkMode: boolean;
  toggleDarkMode: () => void;
  recentShipments: Array<{ id: string; reference: string }>;
  addRecentShipment: (s: { id: string; reference: string }) => void;
}

export const useUIStore = create<UIState>((set) => ({
  commandPaletteOpen: false,
  setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),
  sidebarOpen: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  offlinePending: 0,
  setOfflinePending: (count) => set({ offlinePending: count }),
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  setIsOnline: (online) => set({ isOnline: online }),
  darkMode: true,
  toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
  recentShipments: [],
  addRecentShipment: (s) =>
    set((state) => {
      const filtered = state.recentShipments.filter((r) => r.id !== s.id);
      return { recentShipments: [s, ...filtered].slice(0, 10) };
    }),
}));
